(() => {
  angular
    .module('app.core')
    .factory('CampaignService', CampaignService);

  CampaignService.$inject = ['$resource'];

  function CampaignService($resource) {
    const campaign = $resource('/campaign/:action/:id', {}, {
      'query': {
        method: 'GET',
        params: {
          action: 'query'
        }
      },
      'get': {
        method: 'GET',
        params: {
          action: 'get'
        }
      },
      'empty': {
        method: 'GET',
        params: {
          action: 'emptyobj'
        }
      },
      'delete': {
        method: 'POST',
        params: {
          action: 'delete'
        }
      },
      'save': {
        method: 'POST',
        params: {
          action: 'save'
        }
      },
      'update': {
        method: 'POST',
        params: {
          action: 'update'
        }
      },
      'search': {
        method: 'GET',
        isArray: true,
        params: {
          action: 'search'
        },
        transformResponse: data => {
          const campaigns = JSON.parse(data);
          return Array.isArray(campaigns) ? campaigns : [];
        },
      },
      'setReferenceId': {
        method: 'POST',
        params: {
          action: 'setreferenceid'
        }
      },
      'sendToAdvantEdge': {
        method: 'POST',
        params: {
          action: 'sendtotechedge'
        }
      },
      'getCampaignSnapshots': {
        method: 'GET',
        params: {
          action: 'getcampaignsnapshots'
        }
      },
      'saveCampaignSnapshots': {
        method: 'POST',
        params: {
          action: 'savecampaignsnapshots'
        }
      },
      'deleteCampaignSnapshots': {
        method: 'POST',
        params: {
          action: 'deletecampaignsnapshots'
        }
      },
      'getCampaignOptionsDms': {
        method: 'GET',
        params: {
          action: 'getcampaignoptionsdms'
        }
      },
      'saveCampaignOptionsDms': {
        method: 'POST',
        params: {
          action: 'savecampaignoptionsdms'
        }
      },
      'getTrackpointsWithEventCount': {
        method: 'GET',
        params: {
          action: 'gettrackpointswitheventcount'
        }
      },
      'getCampaignsIntegratedAccounts': {
        method: 'GET',
        params: {
          action: 'getcampaignsintegratedaccounts'
        }
      },
      'getCampaignsAdhAccounts': {
        method: 'GET',
        params: {
          action: 'getcampaignsadhaccounts'
        }
      },
      'getCampaignsWithTrackpointsList': {
        method: 'GET',
        params: {
          action: 'getcampaignswithtrackpointslist'
        }
      },
    });

    campaign.getPaginated = function (
      pageId,
      itemsPerPage,
      sortPredicate,
      isSortOrderAscending,
      filters = {},
    ) {
      var request = {
        action: 'query',
        pageId: pageId,
        itemsPerPage: itemsPerPage,
        sortPredicate: sortPredicate,
        sortOrder: isSortOrderAscending ? 'asc' : 'desc'
      };

      if (filters.labels && filters.labels.length > 0) {
        request = {
          ...request,
          'labels[]': filters.labels,
          operator: filters.operator
        };
      }

      if (filters.type) {
        request = {
          ...request,
          type: filters.type
        };
      }

      if (filters.fusionAccount) {
        request = {
          ...request,
          fusionAccount: filters.fusionAccount
        };
      }

      if (filters.provider) {
        request = {
          ...request,
          provider: filters.provider
        };
      }

      return campaign.get(request).$promise;
    };

    campaign.prototype.equals = function (p) {
      if (!compare(this.name, p.name) ||
          !compare(this.panel_country, p.panel_country) ||
          !compare(this.start, p.start) ||
          !compare(this.end, p.end))
        return false;
      if (!angular.equals(this.labels, p.labels))
        return false;
      if (!angular.equals(this.ris, p.ris))
        return false;
      if (!angular.equals(this.customSegments, p.customSegments))
        return false;
      return angular.equals(this.target, p.target);
    };

    function compare(s1, s2) {
      if (!s1) s1 = '';
      if (!s2) s2 = '';
      return s1 == s2;
    }

    return campaign;
  }

})();
